<script setup lang="ts">
import KsoActions from "@innoclouds/ui/templates/kso/ksoActions/KsoActions.vue";
import { useTranslation } from "i18next-vue";
import { computed } from "vue";
import { useDecorationStore } from "#/store/decoration";
import { formatPrice } from "#/utils/i18next";

interface Props {
	bonusesAvailable: boolean;
	bonusesOpen: boolean;
	bonusesText: string;
	total: number;
	currencySymbol: string | null;
	payDisabled: boolean;
	decoration?: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{ "toggle-bonuses": []; pay: [] }>();

const { t } = useTranslation();
const decor = useDecorationStore().screen(props.decoration);

const payLabel = computed(() => t(`cart.button.pay`));
const payAmount = computed(() => formatPrice(props.total, props.currencySymbol));
</script>

<template>
	<KsoActions
		:bonuses-available="props.bonusesAvailable"
		:bonuses-open="props.bonusesOpen"
		:bonuses-text="props.bonusesText"
		:pay-label="payLabel"
		:pay-amount="payAmount"
		:pay-disabled="props.payDisabled"
		:decor="decor"
		@toggle-bonuses="emit('toggle-bonuses')"
		@pay="emit('pay')"
	/>
</template>
